import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { Router } from 'react-router-dom';
import createHistory from 'history/createHashHistory';
import makeInspectable from 'mobx-devtools-mst';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { StoreEnvironment } from './store/interfaces/StoreEnvironment';
import config from './config';
import { ApiFetcherImpl, PlannerApiFetcherImpl } from './api';
import { RootStore } from './store';
import App from './app';
import LocaleProvider from './components/layout/LocaleProvider';
import 'moment/locale/fr';
import 'core-js';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';

const history = createHistory();

const injectedEnvironment: StoreEnvironment = {
  config,
  history,
  api: new ApiFetcherImpl({ apiUrl: config.apiUrl }),
  plannerApi: new PlannerApiFetcherImpl({ apiUrl: config.plannerApiUrl }),
};

const store = RootStore.create({}, injectedEnvironment);

makeInspectable(store);

(window as any).RootStore = store;
ReactDOM.render(
  <Provider {...store}>
    <LocaleProvider>
      <Router history={history}>
        <App />
      </Router>
    </LocaleProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
